import React from "react"
import PropTypes from "prop-types"

const SectionBlockHeading = ({ heading, headingType }) => {
  // defaltProps would seem the best option but since Contentful sends null values instead of undefined this check is anyways needed.
  const Heading = headingType || "h2"
  return <Heading>{heading}</Heading>
}

SectionBlockHeading.propTypes = {
  heading: PropTypes.string,
  headingType: PropTypes.string,
}

export default SectionBlockHeading
